import fetchAPI from '../utils/service';

function getLayoutMenuRequest() {
  return {
    type: 'GET_LAYOUT_MENU_REQUEST',
  };
}
function getLayoutMenuSuccess(payload) {
  return {
    type: 'GET_LAYOUT_MENU_SUCCESS',
    payload,
  };
}
function getLayoutMenuFailure() {
  return {
    type: 'GET_LAYOUT_MENU_FAILURE',
  };
}

function getLayoutMenu() {
  return async (dispatch) => {
    await dispatch(getLayoutMenuRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/menu',
      });
      if (res.status === 200) {
        await dispatch(getLayoutMenuSuccess(res.data));
      } else {
        await dispatch(getLayoutMenuFailure());
      }
    } catch (error) {
      await dispatch(getLayoutMenuFailure());
    }
  };
}

function getInitialsRequest() {
  return {
    type: 'GET_INITIALS_REQUEST',
  };
}
function getInitialsSuccess(payload) {
  return {
    type: 'GET_INITIALS_SUCCESS',
    payload,
  };
}
function getInitialsFailure() {
  return {
    type: 'GET_INITIALS_FAILURE',
  };
}

function getInitials(limit) {
  return async (dispatch) => {
    await dispatch(getInitialsRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/',
        params: limit && { limit },
      });
      if (res.status === 200) {
        await dispatch(getInitialsSuccess(res.data));
      } else {
        await dispatch(getInitialsFailure());
      }
    } catch (error) {
      await dispatch(getInitialsFailure());
    }
  };
}

function getContactsRequest() {
  return {
    type: 'GET_CONTACTS_REQUEST',
  };
}
function getContactsSuccess(payload) {
  return {
    type: 'GET_CONTACTS_SUCCESS',
    payload,
  };
}
function getContactsFailure() {
  return {
    type: 'GET_CONTACTS_FAILURE',
  };
}

function getContacts() {
  return async (dispatch) => {
    await dispatch(getContactsRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/contact',
      });
      if (res.status === 200) {
        await dispatch(getContactsSuccess(res.data));
      } else {
        await dispatch(getContactsFailure());
      }
    } catch (error) {
      await dispatch(getContactsFailure());
    }
  };
}

function getUtilityDocumentsRequest() {
  return {
    type: 'GET_UTILITY_DOCUMENTS_REQUEST',
  };
}
function getUtilityDocumentsSuccess(payload) {
  return {
    type: 'GET_UTILITY_DOCUMENTS_SUCCESS',
    payload,
  };
}
function getUtilityDocumentsFailure() {
  return {
    type: 'GET_UTILITY_DOCUMENTS_FAILURE',
  };
}

function getUtilityDocuments() {
  return async (dispatch) => {
    await dispatch(getUtilityDocumentsRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/utility-document',
      });
      if (res.status === 200) {
        await dispatch(getUtilityDocumentsSuccess(res.data));
      } else {
        await dispatch(getUtilityDocumentsFailure());
      }
    } catch (error) {
      await dispatch(getUtilityDocumentsFailure());
    }
  };
}

export {
  getInitials,
  getContacts,
  getUtilityDocuments,
  getLayoutMenu,
};



// WEBPACK FOOTER //
// ./src/actions/app.js